import React from "react";

const WorkExperience = () => {
  return (
    <div>
      <div className="my-4 grid grid-cols-12 gap-4">
        <div className="col-span-3 sub-heading mt-0">Work Experience</div>
        <div className="col-span-9">
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left text-app-text-secondary ">
              <thead className="text-xs text-app-text uppercase bg-app-surface-muted  ">
                <tr>
                  <th scope="col" className="px-6 py-5 text-base">
                    Name of Organization
                  </th>
                  <th scope="col" className="px-6 py-5 text-base">
                    From
                  </th>
                  <th scope="col" className="px-6 py-5 text-base">
                    To
                  </th>
                  <th scope="col" className="px-6 py-5 text-base">
                    Document Uploaded
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-app-surface border-b ">
                  <th scope="row" className="px-6 py-4 font-medium text-app-text whitespace-nowrap">
                    Apple MacBook Pro 17"
                  </th>
                  <td className="px-6 py-4">Silver</td>
                  <td className="px-6 py-4">Laptop</td>
                  <td className="px-6 py-4">$2999</td>
                </tr>
                <tr className="border-b bg-app-surface-muted  ">
                  <th scope="row" className="px-6 py-4 font-medium text-app-text whitespace-nowrap">
                    Microsoft Surface Pro
                  </th>
                  <td className="px-6 py-4">White</td>
                  <td className="px-6 py-4">Laptop PC</td>
                  <td className="px-6 py-4">$1999</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkExperience;
